/**
 * mutation 必须同步执行
 */
import { setStore } from "@/store/storage";
export default {
  setToken(state, token) {
    state.token = token;
  },
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
    setStore('userInfo', userInfo);
  },
   //清空用户数据
  logout (state) {
    // Cookies.remove('userInfo')
    localStorage.clear();
    state.userInfo = {};
    // router.push('/login');
  },
  setValueSet(state, data) {
    state.valueSet = data;
  },
  setMessageList (state, messageList) {
    state.messageList = messageList || []
  },
  setFrom (state, from) {
    state.from = from;
  },
};
